<template>
    <div>
        <v-layout wrap row justify-center align-center text-xs-center pb-5 mt-5 class="cont_page">
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-center">
                <img class="animated bounceIn dura-1" src="@/assets/unidad1/pantalla-10-1.png" alt="seguridad">
            </v-flex>
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-center">
                <h2 class="animated bounceIn dura-2 tituloUnidad">¡Muy bien! Has finalizado la primera unidad</h2>
                <p  class="animated bounceIn dura-3">Continúa con la segunda unidad en la que conocerás todo lo relacionado con la Evaluación de atmósferas, las personas autorizadas, los equipos y la ejecución de la prueba de gases.</p>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import nextConditions from "../../js/mixins/nextConditions";
export default {
    mixins: [nextConditions],
    data() {
        return {}
    },
    mounted() {
        setTimeout(() => {
            this.$store.commit('nextShow', true)
        }, 3000);
    },
}
</script>

<style lang="scss" scoped>
@import '../../sass/globals';
  .tituloUnidad {
        color: $color-primary;
    }
.icon-titulo {
    content: url('../../assets/imagenes_compartidas/icon-titulo.png');
    align-items: center;
    justify-content: start;
    width: 15px;
    height: 15px;
}

ol {
    list-style: none;
    counter-reset: my-awesome-counter;
    padding-left: 10px;
}

ol li {
    counter-increment: my-awesome-counter;
    display: flex;
    align-items: center;
    justify-content: start;
    span {
        margin: 0.5em;
        padding: 0.5em;
        border-left: 2px solid $color-complement-one;
    }
}

ol li::before {
    content: counter(my-awesome-counter) ". ";
    color: $color-primary;
    font-weight: bold;
    margin-right: 0.01em;
}

li {}

.container-module {
    text-align: left;
    p {
        margin: 0;
        padding: 0;
    }
    img {
        width: 80px;
        display: inline-block;
        vertical-align: middle;
    }
    .modulo-name {
        display: inline-block;
        vertical-align: middle;
        width: 80%;
        text-align: left;
        padding-left: 10px;
    }
    @media screen and (max-width: 500px) {
        text-align: center;
        img {
            width: 40%;
        }
        .modulo-name {
            width: 100%;
            padding-left: 0px;
        }
    }
}
</style>